import React, { Component } from "react";
import ModalWrapper, { withOnClose } from "../ModalWrapper";
import Translator from "src/requests/apa/Translator";
import { Button } from "packages/components";
import './styles.scss'
import { autobind } from "packages/core/lib";
import store from "src/store";
import { HIDE_MODAL } from "src/actions/modal";
import { removeDynamicFocus } from "src/components/Focus/utils";
import { ADEUDOLINEATEMEX, MODALADEUDOLINEATEMEX, ACEPTAR } from '../../../AAFPlayer/constants';
import {GA4} from '../../../utils/trackers/GA4';
import Utils from '../../../utils/Utils';

interface IProps {
    callbackWhenBack: () => void
    dataMetrics2FA: any;
    history: any
}

class OnlineDebt extends Component<IProps> {
  getParamsMetrics2FA: any;

  constructor(props: IProps){
    super(props);
    this.getParamsMetrics2FA = Utils.getParamsMetricsModals2FA(props.dataMetrics2FA, ADEUDOLINEATEMEX , props.history.location.pathname, MODALADEUDOLINEATEMEX);
  }

  componentDidMount(): void {
    removeDynamicFocus();
  }

  sendGA4Metric(){
    const gA4 = new GA4();
    gA4.sendMetrics2FA(this.getParamsMetrics2FA, ACEPTAR);
  }
    
  @autobind
  handleClick() {
    this.sendGA4Metric();
    this.props.callbackWhenBack()
    store.dispatch({
        type: HIDE_MODAL
    })
    if(window.location.href.includes('detailtransaction')) history.back()
  }

  render() {
    return (
      <ModalWrapper callbackWhenBack={this.props.callbackWhenBack}>
        <div className='FullHD online-debt'>
          <h1>{Translator.get('Alerta_2FATelmex_AdeudoLinea_TextoTitulo')}</h1>
          <p className="detect-debt">{Translator.get('Alerta_2FATelmex_AdeudoLinea_TextoMensaje1')}</p>

          <p className="contact">
            {Translator.get('Alerta_2FATelmex_AdeudoLinea_TextoMensaje2_Parte1')}
            <span> {Translator.get('Alerta_2FATelmex_AdeudoLinea_TextoMensaje2_Parte2')} </span>
             {Translator.get('Alerta_2FATelmex_AdeudoLinea_TextoMensaje2_Parte3')}
          </p>
        
            <div>
                <Button
                    type="button"
                    className="btn focusable"
                    onClick={this.handleClick}
                >
                    {Translator.get('Alerta_2FATelmex_TextoBotonPrimario_Aceptar')}
                </Button>
            </div>
        
            
            <h2>{Translator.get('Alerta_2FATelmex_TextoTituloAyuda')}</h2>
            <p className="help-text ">{Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoAyuda1')}</p>
            <p className="help-text ">{Translator.get('Alerta_2FATelmex_CodigoExpirado_TextoAyuda2')}</p>
        </div>
       
      </ModalWrapper>
    )
  }
}


export default withOnClose(OnlineDebt);



// WEBPACK FOOTER //
// ./src/components/Modal/OnlineDebt/OnlineDebt.tsx